import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { DateModule } from '../../../common/date/date.module';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { TooltipModule } from '../../../common/tooltip/tooltip.module';
import { RtUIDialogsModule } from '../../../dialogs/dialogs.module';
import { RtUICoreOverlayModule } from './../../../core/core.module';
import { AttachmentItemComponent } from './attachment-item.component';

@NgModule({
  exports: [AttachmentItemComponent],
  imports: [
    CommonModule,
    I18nModule,
    TooltipModule,
    RtUICoreOverlayModule,
    DateModule,
    RtUIDialogsModule,
    PipesModule,
    AttachmentItemComponent,
  ],
})
export class AttachmentItemModule {}

export { AttachmentItemComponent, AttachmentItemTranslations } from './attachment-item.component';
